module.exports = __webpack_public_path__ + "img/Gold Standard.f0ce69d7.jpg";